<template>
  <!-- 真正的下载落地页是 public/index.html + public/mob.html（纯 HTML + jQuery）
       这里保留一个隐藏挂载点让 Vue 实例安静挂载、不产生控制台警告。
       如果将来要把页面改造成 SPA（Vue 组件化），这里就是入口。 -->
  <div></div>
</template>

<script>
export default {
  name: 'App'
}
</script>
